export default "__VITE_ASSET__2d93ZtZF__"